"use strict";

exports.__esModule = true;
exports.default = void 0;
const shouldUseFlex = props => props.flex || Object.keys(props).map(item => !(item === "children" || item === "spaceAfter" || item === "spacing" || item === "dataTest")).indexOf(true) !== -1;
var _default = shouldUseFlex;
exports.default = _default;